import { getSiblingValueByTargets, isRequiredText, strMax } from '../../utils';
export default {
    position: [isRequiredText('役職を選択してください')],
    positionOther: (otherId) => (value, record, formProp, name) => {
        const targetValue = getSiblingValueByTargets(name, record, 'position');
        if ((targetValue || '').toString() === otherId.toString()) {
            return (isRequiredText('その他を入力してください')(value) ||
                strMax(50, 'その他は50文字以内で入力してください')(value) ||
                '');
        }
        return '';
    },
};
